import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom'
import EmbroideryViewer from './stitchviewer';
import SvgViewer from './svgviewer';
import NexusViewer from './nexusviewer';
import PrivateRoute from '../../../PrivateRoute';

export default class Embroidery extends Component {
    render() {
        const { match } = this.props;
        return (
            <div id="layoutSidenav_content">
                <main>
                    <Switch>
                        <Route path={[`${match.path}/stitchviewer`]} component={EmbroideryViewer} />
                        <Route path={[`${match.path}/canvas`]} component={SvgViewer} />
                        <PrivateRoute path={[`${match.path}/nexus`]} component={NexusViewer} />
                    </Switch>
                </main>
            </div>
        );
    }
}